import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import models from "../../model-declaration";
import { formatUnderscoreToSpace } from "../../utils/text-format";
import closeIcon from "../../assets/icons/close-icon.svg";
import { useRole } from "../../context/role/RoleContext";

const SidebarDrawer = ({ open, onClose = () => {}, columns, references }) => {
  const loaction = useLocation();
  const { state } = useRole();
  return (
    <div
      className={`
    fixed top-0 left-0 h-full w-full max-w-[30rem] bg-white shadow-lg z-[5056] py-5
    transform transition-transform duration-300 ease-in-out 
    ${open ? "translate-x-0" : "-translate-x-full"}
  `}
    >
      <div className="flex items-center justify-between w-full px-5">
        <h3 className="text-lg font-bold mb-4"></h3>
        <button
          type="button"
          className="p-1 bg-gray-100 rounded-full"
          onClick={onClose}
        >
          <img src={closeIcon} alt="X" width={24} height={24} />
        </button>
      </div>
      <ul className="flex flex-col gap-1 h-full overflow-auto px-5 pb-4">
        <NavLink
          to={`/dashboard`}
          className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
            loaction.pathname.split("/")[1] === "dashboard"
              ? "bg-primary text-white"
              : ""
          }`}
        >
          Dashboard
        </NavLink>
        {(state?.role?.employee?.read || state?.role?.employee?.write) && (
          <NavLink
            onClick={onClose}
            to={`/admin/users/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[2] === "users"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            employees
          </NavLink>
        )}
        {state?.role?.type === "admin" && (
          <NavLink
            onClick={onClose}
            to={`/admin/roles/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[2] === "roles"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            employee Roles
          </NavLink>
        )}

        {(state?.role?.company?.read || state?.role?.company?.write) && (
          <NavLink
            onClick={onClose}
            to={`/company/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "company"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            Company
          </NavLink>
        )}

        <NavLink
          to={`/designation/list`}
          className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
            loaction.pathname.split("/")[1] === "designation"
              ? "bg-primary text-white"
              : ""
          }`}
        >
          designation
        </NavLink>

        <NavLink
          onClick={onClose}
          to={`/department/list`}
          className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
            loaction.pathname.split("/")[1] === "department"
              ? "bg-primary text-white"
              : ""
          }`}
        >
          department
        </NavLink>

        {(state?.role?.product?.read || state?.role?.product?.write) && (
          <NavLink
            onClick={onClose}
            to={`/product/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "product"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            product
          </NavLink>
        )}

        {(state?.role?.lead?.read || state?.role?.lead?.write) && (
          <NavLink
            onClick={onClose}
            to={`/lead/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "lead"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            Lead
          </NavLink>
        )}

        {(state?.role?.lead_activity?.read ||
          state?.role?.lead_activity?.write) && (
          <NavLink
            onClick={onClose}
            to={`/lead-activity/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "lead-activity"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            Lead activity
          </NavLink>
        )}

        {(state?.role?.customer?.read || state?.role?.customer?.write) && (
          <NavLink
            onClick={onClose}
            to={`/customer/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "customer"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            Customer
          </NavLink>
        )}

        {(state?.role?.customer_activity?.read ||
          state?.role?.customer_activity?.write) && (
          <NavLink
            onClick={onClose}
            to={`/customer-activity/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "customer-activity"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            customer activity
          </NavLink>
        )}

        {(state?.role?.order?.read || state?.role?.order?.write) && (
          <NavLink
            onClick={onClose}
            to={`/orders/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "orders"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            orders
          </NavLink>
        )}

        {(state?.role?.payment?.read || state?.role?.payment?.write) && (
          <NavLink
            onClick={onClose}
            to={`/payment/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "payment"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            Payment
          </NavLink>
        )}

        {(state?.role?.payment?.read || state?.role?.payment?.write) && (
          <NavLink
            onClick={onClose}
            to={`/employee-request/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "employee-request"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            employee request
          </NavLink>
        )}

        {(state?.role?.marketing_material?.read ||
          state?.role?.marketing_material?.write) && (
          <NavLink
            to={`/marketing-materials-category/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "marketing-materials-category"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            marketing materials category
          </NavLink>
        )}

        {(state?.role?.marketing_material?.read ||
          state?.role?.marketing_material?.write) && (
          <NavLink
            onClick={onClose}
            to={`/marketing-materials/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "marketing-materials"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            marketing materials
          </NavLink>
        )}

        <NavLink
          onClick={onClose}
          to={`/state/list`}
          className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
            loaction.pathname.split("/")[1] === "state"
              ? "bg-primary text-white"
              : ""
          }`}
        >
          state
        </NavLink>

        <NavLink
          onClick={onClose}
          to={`/city/list`}
          className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
            loaction.pathname.split("/")[1] === "city"
              ? "bg-primary text-white"
              : ""
          }`}
        >
          city
        </NavLink>

        <NavLink
          onClick={onClose}
          to={`/tile-layers/list`}
          className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
            loaction.pathname.split("/")[1] === "tile-layers"
              ? "bg-primary text-white"
              : ""
          }`}
        >
          Tile layers
        </NavLink>

        <NavLink
          onClick={onClose}
          to={`/expense/list`}
          className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
            loaction.pathname.split("/")[1] === "expense"
              ? "bg-primary text-white"
              : ""
          }`}
        >
          Expense
        </NavLink>

        {models?.map((model, index) => (
          <NavLink
            key={index}
            to={`/${model?.tableName}/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === model?.tableName
                ? "bg-primary text-white"
                : ""
            }`}
          >
            {formatUnderscoreToSpace(model?.tableName)}
          </NavLink>
        ))}
      </ul>
    </div>
  );
};

export default SidebarDrawer;
